import React, { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, DialogContent, DialogTitle, DialogActions, Dialog, Grid } from '@material-ui/core';

import TextField from '@material-ui/core/TextField';
import { useNotify } from '../../hooks/useNotify';
import { doSwaggerCall } from '../../hooks/useSwaggerClient';

function CreateNewChainModal({ showModal, MODAL_TYPE }) {
    const [name, setName] = useState(null);
    const { notifySuccess, notifyError } = useNotify();
    const history = useHistory();

    const createChain = useCallback(() => {
        doSwaggerCall('chains', 'createChain', {
            newChain: {
                name
            }
        })
            .then(newChain => {
                notifySuccess('New chain created!');
                showModal(MODAL_TYPE.NONE);
                history.push(`/admin/chains/update/${newChain.id}`);
            })
            .catch(err => {
                console.log(err);
                notifyError('Error during chain creation!');
            });
    }, [name, notifySuccess, notifyError, showModal, history]);

    return (
        <form>
            <Dialog
                aria-labelledby="client-modal"
                open
                onClose={() => showModal(MODAL_TYPE.NONE)}
                maxWidth="md"
            >
                <DialogTitle>Create new chain</DialogTitle>
                <DialogContent>
                    <form
                        id="newchain-form"
                        onSubmit={ev => {
                            ev.preventDefault();
                            createChain();
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Name"
                                    type="text"
                                    value={name}
                                    onChange={ev => setName(ev.target.value)}
                                />
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={() => showModal(MODAL_TYPE.NONE)}>
                        Close
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!name}
                        type="submit"
                        form="newchain-form"
                    >
                        Submit
                    </Button>
                </DialogActions>
            </Dialog>
        </form>
    );
}

export default CreateNewChainModal;
